import { useQuery } from 'hooks/useCustomQuery';
import { getAllAdminUsers } from 'API/AdminUser';

/** (3153) The company's admin accounts, to find admins who stopped logging in. */
const useGetCompanyAdminUsers = (companyId, options = {}) =>
    useQuery({
        queryKey: ['dashboardHome', 'adminUsers', companyId],
        queryFn: async () => (await getAllAdminUsers(companyId)) || [],
        enabled: !!companyId,
        refetchOnWindowFocus: false,
        retry: false,
        ...options,
    });

export default useGetCompanyAdminUsers;
